<template>
  <div class="login-page">
    <app-navbar />
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using:
        data-color="blue | azure | green | orange | red | purple" -->
        <div class="content no-account-card-container">
          <div class="container">
            <div class="col-lg-6 col-md-6 ml-auto mr-auto">
              <card type="login">
                <h4 class="header text-center">
                  <b>Are you a student trying to access Acts?</b>
                  Once you are marked as a <i>commissioned disciple</i>, you will be sent an invite link.
                  <br>
                  <br>
                  <b>Have you logged in previously?</b>
                  <br>
                  You've tried to log in with an incorrect email.
                  Click below to go back and log in with another email.
                </h4>
                <div class="text-center btn-wrapper" style="display:block;">
                  <p-button
                    native-type="submit"
                    round
                    class="mb-3 return-to-login"
                    style="margin-right:5%"
                    block
                    @click="oneloginLogout"
                  >
                    Return to Login Page
                  </p-button>
                </div>
                <a class="bottom-left-link" :href="smartsheet" target="_blank">
                  I'm a Student and I Still Need Help
                </a>
                <a class="bottom-right-link" @click="goToNoAccountNonStudent" href="#">
                  I'm not a Student
                </a>
              </card>
            </div>
          </div>
        </div>
        <app-footer />
        <div class="full-page-background" style="background-image: url(static/img/background/background-2.jpg) " />
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from 'src/components/Layout/LoginAppNavbar';
import AppFooter from 'src/components/Layout/LoginAppFooter';
import Mgr from 'src/services/SecurityService';

export default {
    components: {
        AppNavbar,
        AppFooter
    },
    data() {
        return {
            mgr: new Mgr(),
            smartsheet: process.env.VUE_APP_SMARTSHEET,
        };
    },
    methods: {
        async oneloginLogout() {
            // Redirect the user to OneLogin logout URL
            window.location.href = 'https://focusdsc.onelogin.com/logout';
        },
        goToNoAccountNonStudent(event) {
            event.preventDefault();
            this.$router.replace('/no-account-non-student');
        }
    }
};
</script>
<style>
.bottom-left-link,
.bottom-right-link {
  position: absolute;
  bottom: 0;
  padding: 10px; /* Adjust padding as needed */
  color: #66b1ff !important;
}

.bottom-left-link {
  left: 0;
}

.bottom-right-link {
  right: 0;
}

.btn-wrapper {
  margin-bottom: 25px;
}
.no-account-card-container {
 padding-top: 10vh !important;
}
.return-to-login {
  background-color: #0B3B60 !important;
}
@media (max-width: 768px) {
  .bottom-left-link,
  .bottom-right-link {
    position: relative;
    text-align: center; /* Center-align the links */
    width: 100%; /* Make the links full width */
  }
}
</style>
